import { combineReducers } from "redux";

import { ticketsReducer as ticketsList } from "./ticketList/ticketListSlice";
import { ticketMessagesReducer } from "./ticketMessages/ticketMessagesReducer";
import { reducer as readTicketsIds } from "./ticketsRead/ticketsReadActions";
import ticketDetail from "./ticketDetail";

export default combineReducers({
  ticketDetail,
  ticketsMessagesReducer: ticketMessagesReducer,
  ticketsList,
  readTicketsIds,
});
